// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dismiss{float:right;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:1.25rem;line-height:1.75rem;line-height:1}.dismiss:hover{--tw-text-opacity:1;color:rgba(156, 163, 175, var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
